"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M29.912 22.12c0-.007.035-.029.026-.029a8.481 8.481 0 0 1-7.138-4.017c-.017-.028-.046-.047-.064-.074.019-.027.047-.046.064-.074a8.481 8.481 0 0 1 7.142-4.017c.009 0-.023-.022-.026-.029a5.917 5.917 0 1 0-3.93-1.588l-6.47 3.445-12.6-6.7a4 4 0 0 0-3.8.023L.822 10.313 15.26 18 .822 25.687l2.292 1.255a4 4 0 0 0 3.8.023l12.6-6.7 6.47 3.445a5.892 5.892 0 1 0 3.93-1.588zm.367-18.039a3.933 3.933 0 1 1-4.205 3.641 3.933 3.933 0 0 1 4.205-3.64zm0 27.837a3.933 3.933 0 1 1 3.641-4.205 3.933 3.933 0 0 1-3.641 4.205z" })
);

